import { M1TestShackReportPage } from "./M1TestShackReportPage";

export default M1TestShackReportPage;
